module.exports = __webpack_public_path__ + "static/img/culture3.e7c8bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture3.png
// module id = iof8
// module chunks = 1